// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"f2e97d49","232":"46ede41e","382":"a1c138da"}[chunkId] + ".chunk.js";
};